import React, { useState, useRef, useEffect } from 'react';
import { Text } from '@pixi/react';
import * as PIXI from 'pixi.js';

const AnnotationText = ({ annotation, setAnnotations }) => {
  const [dragOffset, setDragOffset] = useState(null);

  // Drag logic
  useEffect(() => {
    if (!dragOffset) return;
    
    const handlePointerMove = (e) => {
      // Get the canvas element to calculate correct coordinates
      const canvas = document.querySelector('canvas');
      if (!canvas) return;
      
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      setAnnotations(prev => prev.map(a =>
        a.id === annotation.id ? { ...a, x: x - dragOffset.x, y: y - dragOffset.y } : a
      ));
    };
    
    const handlePointerUp = () => {
      setDragOffset(null);
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', handlePointerUp);
    };
    
    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerup', handlePointerUp);
    
    return () => {
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', handlePointerUp);
    };
  }, [dragOffset, annotation.id, setAnnotations]);

  // Drag start
  const handlePointerDown = (e) => {
    // Calculate offset from the text position to the pointer position
    const offsetX = e.data.global.x - annotation.x;
    const offsetY = e.data.global.y - annotation.y;
    
    setDragOffset({ x: offsetX, y: offsetY });
  };

  return (
    <Text
      text={annotation.text}
      x={annotation.x}
      y={annotation.y}
      interactive
      pointerdown={handlePointerDown}
      style={new PIXI.TextStyle({
        fontSize: 18,
        fontWeight: 400,
        fill: '#222',
        stroke: '#fff',
        strokeThickness: 1,
        dropShadow: true,
        dropShadowColor: '#000',
        dropShadowBlur: 1,
        dropShadowDistance: 1,
        padding: 2,
      })}
    />
  );
};

export default AnnotationText; 